"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionReferenceConditionSchema = void 0;
const zod_1 = require("zod");
exports.FunctionReferenceConditionSchema = zod_1.z.object({
    function: zod_1.z.string(),
    function_state: zod_1.z.boolean(),
});
//# sourceMappingURL=FunctionReferenceCondition.js.map